/*
  Product zone map (snippets/product-zone-map.liquid).

  - Reads the product's "Grow Zones" text, e.g. "4-9 Patios / 9-11 Outdoors",
    and shades the zone finder's map: outdoor zones dark, patio or indoor
    zones light. Every format in the catalogue on 8 October 2026 parsed.
  - A ZIP check says whether the product is listed for that zone, using only
    the product's own listing. Map clicks do the same for the spot clicked.
  - A zone found by ZIP is shared with the zone finder through localStorage
    (the zone, never the ZIP), so it is shown here on later visits.
  - A ZIP is also checked against the "Does Not Ship To" / "Only Ships To"
    row, by the ZIP's first three digits, for the states that row names.
  - The expand button lifts the same card into a dialog. Nothing is duplicated.
*/
(function () {
  var roots = document.querySelectorAll('[data-product-zone]');
  if (!roots.length) return;

  var HALF = [];
  for (var n = 1; n <= 13; n++) { HALF.push(n + 'a', n + 'b'); }
  var B36 = '0123456789abcdefghijklmnopqrstuvwxyz';
  var STORE_KEY = 'eureka-zone';
  var zipData = null;

  function store(zone) { try { localStorage.setItem(STORE_KEY, zone); } catch (e) {} }
  function stored() { try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; } }

  function loadZips(url) {
    if (zipData) return Promise.resolve(zipData);
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) { zipData = d; return d; });
  }

  function lookup(zip) {
    var rec = zipData.substr(parseInt(zip, 10) * 5, 5);
    if (!rec || rec.charAt(0) === '.') return null;
    var zone = HALF[rec.charCodeAt(0) - 97];
    var xy = rec.substr(1);
    if (xy === 'zzzz') return { zone: zone };
    return {
      zone: zone,
      x: B36.indexOf(xy.charAt(0)) * 36 + B36.indexOf(xy.charAt(1)),
      y: B36.indexOf(xy.charAt(2)) * 36 + B36.indexOf(xy.charAt(3))
    };
  }

  // "4-9 Patios / 8B-11 Outdoors" -> { outdoor: {lo:'8b', hi:'11b', label:'8b–11'}, pot: {...}, indoor: false }
  // An unlabelled range is read as outdoors, which is what a USDA range means.
  function parseZones(text) {
    var out = { outdoor: null, pot: null, indoor: false };
    String(text).replace(/^[^:|]*zones?[^:|]*[:|]\s*\|?/i, '').split(/[\/,;]/).forEach(function (seg) {
      var s = seg.toLowerCase();
      var m = s.match(/(\d{1,2})\s*([ab])?\s*(?:-|–|to)\s*(\d{1,2})\s*([ab])?/) || s.match(/(\d{1,2})\s*([ab])?/);
      if (/indoor/.test(s)) out.indoor = true;
      if (!m) return;
      var a = +m[1], b = +(m[3] || m[1]);
      if (a < 1 || b > 13 || a > b) return;
      var kind = /patio|indoor|container|pot/.test(s) ? 'pot' : 'outdoor';
      out[kind] = {
        lo: a + (m[2] || 'a'),
        hi: b + (m[4] || (m[3] ? 'b' : (m[2] || 'b'))),
        label: a + (m[2] || '') + (m[3] ? '–' + b + (m[4] || '') : '')
      };
    });
    return out;
  }

  // USPS three-digit ZIP prefixes for every state the catalogue's shipping row
  // names (8 October 2026). Add a state here if a new one appears in that row.
  var STATES = {
    AL: ['Alabama', [[350, 369]]], AZ: ['Arizona', [[850, 865]]], CA: ['California', [[900, 961]]],
    FL: ['Florida', [[320, 339], [341, 349]]], GA: ['Georgia', [[300, 319], [398, 399]]],
    LA: ['Louisiana', [[700, 714]]], OR: ['Oregon', [[970, 979]]], TX: ['Texas', [[750, 799], [885, 885]]]
  };
  var NAMES = { CALIFORNIA: 'CA', CALIFRONIA: 'CA', FLORIDA: 'FL', ARIZONA: 'AZ', TEXAS: 'TX' };

  function parseShipping(text) {
    var s = String(text).toUpperCase();
    var states = (s.replace(/^[^:|]*[:|]/, '').match(/[A-Z]{2,}/g) || []).map(function (w) { return NAMES[w] || w; })
      .filter(function (c) { return STATES[c]; });
    return { only: /ONLY/.test(s), states: states };
  }

  function stateOf(zip) {
    var z3 = parseInt(zip.substr(0, 3), 10);
    for (var c in STATES) {
      if (STATES[c][1].some(function (r) { return z3 >= r[0] && z3 <= r[1]; })) return c;
    }
    return null;
  }

  // Returns the state name if this ZIP is one we can't ship this plant to.
  function blockedState(zip, ship) {
    if (!ship.states.length) return null;
    var st = stateOf(zip);
    if (ship.only) return ship.states.indexOf(st) > -1 ? null : 'your area';
    return ship.states.indexOf(st) > -1 ? STATES[st][0] : null;
  }

  function within(zone, range) {
    if (!range) return false;
    var i = HALF.indexOf(zone);
    return i >= HALF.indexOf(range.lo) && i <= HALF.indexOf(range.hi);
  }

  roots.forEach(function (root) {
    var plant = parseZones(root.dataset.zones);
    var ship = parseShipping(root.dataset.shipping || '');
    var mapBox = root.querySelector('[data-pzm-map]');
    var wrap = mapBox.parentElement;
    var tip = root.querySelector('[data-pzm-tip]');
    var key = root.querySelector('[data-pzm-key]');
    var form = root.querySelector('[data-pzm-form]');
    var input = root.querySelector('[data-pzm-zip]');
    var error = root.querySelector('[data-pzm-error]');
    var result = root.querySelector('[data-pzm-result]');
    var openBtn = root.querySelector('[data-pzm-open]');
    var closeBtn = root.querySelector('[data-pzm-close]');
    var backdrop = root.nextElementSibling;
    var svg, pin, hovered = null, placeholder = null;

    var potWord = plant.indoor && !/patio/i.test(root.dataset.zones) ? 'Indoors' : 'Patios';
    var keyHtml = '';
    if (plant.outdoor) keyHtml += '<li><i style="background:var(--pzm-out)"></i>Outdoors: zones ' + plant.outdoor.label + '</li>';
    if (plant.pot) keyHtml += '<li><i style="background:var(--pzm-pot)"></i>' + potWord + ': zones ' + plant.pot.label + '</li>';
    else if (plant.indoor) keyHtml += '<li><i style="background:var(--pzm-pot)"></i>Indoors anywhere</li>';
    key.innerHTML = keyHtml;

    // Reports the product's own listing for the zone. It deliberately gives no
    // planting advice: some listed ranges are wider than extension sources
    // allow (8 Oct 2026, flagged to the client), so the card only repeats them.
    function zones(range) { return 'zones <span class="pzm__nb">' + range.label + '</span>'; }
    function listing() {
      var parts = [];
      if (plant.pot) parts.push(zones(plant.pot) + (potWord === 'Indoors' ? ' indoors' : ' on patios'));
      else if (plant.indoor) parts.push('growing indoors');
      if (plant.outdoor) parts.push(zones(plant.outdoor) + ' outdoors');
      return parts.join(', and ');
    }
    function describe(zone) {
      if (within(zone, plant.outdoor)) return { cls: '', head: 'This plant is listed for ' + zones(plant.outdoor) + ' outdoors.', body: '' };
      if (within(zone, plant.pot) || (plant.indoor && !plant.pot)) return { cls: 'is-pot', head: 'This plant is listed for ' + listing() + '.', body: '' };
      return { cls: 'is-no', head: 'Zone ' + zone + ' is outside the zones this plant is listed for.', body: 'It is listed for ' + listing() + '.' };
    }

    function show(r) {
      var d = describe(r.zone);
      var blocked = r.zip ? blockedState(r.zip, ship) : null;
      if (blocked) d = { cls: 'is-no', head: 'We can’t ship this plant to ' + blocked + '.', body: ship.only ? 'It only ships to ' + ship.states.map(function (c) { return STATES[c][0]; }).join(', ') + '.' : '' };
      var lead = r.zip ? r.zip + ' is in zone ' + r.zone + '.' : (r.saved ? 'Your saved zone is ' + r.zone + '.' : (r.spot ? 'That spot is in zone ' + r.zone + '.' : ''));
      result.className = 'pzm__result ' + d.cls;
      result.innerHTML = (lead ? '<p>' + lead + '</p>' : '') + '<p><strong>' + d.head + '</strong></p>' + (d.body ? '<p>' + d.body + '</p>' : '') +
        (r.saved ? '<p><button type="button" data-pzm-change>Check a different ZIP</button></p>' : '');
      result.hidden = false;
      var change = result.querySelector('[data-pzm-change]');
      if (change) change.addEventListener('click', function () { result.hidden = true; placePin(null); input.focus(); });
      if (r.x != null) placePin(r.x, r.y); else placePin(null);
    }

    fetch(root.dataset.mapUrl).then(function (r) { return r.text(); }).then(function (text) {
      mapBox.innerHTML = text;
      svg = mapBox.querySelector('svg');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'Map of the United States. ' + key.textContent.replace(/zones/g, ' zones'));
      svg.querySelectorAll('#zones path').forEach(function (p) {
        var z = p.getAttribute('data-zone');
        if (within(z, plant.outdoor)) p.classList.add('is-out');
        else if (within(z, plant.pot) || (plant.indoor && !plant.pot)) p.classList.add('is-pot');
      });
      pin = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      pin.setAttribute('class', 'zf-pin');
      pin.innerHTML = '<circle class="zf-pin__pulse" r="8"></circle><circle class="zf-pin__dot" r="4.5"></circle>';
      svg.appendChild(pin);
      svg.addEventListener('click', onMapClick);
      if (window.matchMedia('(hover: hover)').matches) {
        svg.addEventListener('mousemove', onHover);
        svg.addEventListener('mouseleave', clearHover);
      }
      root.classList.add('is-ready');
      var saved = stored();
      if (saved && HALF.indexOf(saved) > -1) show({ zone: saved, saved: true });
    });

    function placePin(x, y) {
      if (!pin) return;
      if (x == null) { pin.classList.remove('is-visible'); return; }
      pin.setAttribute('transform', 'translate(' + x + ' ' + y + ')');
      pin.classList.add('is-visible');
    }

    function clearHover() {
      if (hovered) hovered.classList.remove('is-hover');
      hovered = null;
      tip.hidden = true;
    }

    function onHover(e) {
      var target = e.target.closest ? e.target.closest('#zones path') : null;
      if (!target) { clearHover(); return; }
      if (target !== hovered) {
        if (hovered) hovered.classList.remove('is-hover');
        hovered = target;
        hovered.classList.add('is-hover');
        var z = target.getAttribute('data-zone');
        var fit = within(z, plant.outdoor) ? 'Outdoors' : (within(z, plant.pot) ? potWord : 'Not listed');
        tip.innerHTML = '<strong>Zone ' + z + '</strong> · ' + fit;
      }
      var r = wrap.getBoundingClientRect();
      tip.style.left = (e.clientX - r.left) + 'px';
      tip.style.top = (e.clientY - r.top) + 'px';
      tip.hidden = false;
    }

    function onMapClick(e) {
      var target = e.target.closest ? e.target.closest('#zones path') : null;
      if (!target) return;
      var pt = svg.createSVGPoint();
      pt.x = e.clientX; pt.y = e.clientY;
      var p = pt.matrixTransform(svg.getScreenCTM().inverse());
      error.hidden = true;
      show({ zone: target.getAttribute('data-zone'), x: p.x, y: p.y, spot: true });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (input.value || '').trim();
      if (!/^\d{5}$/.test(zip)) {
        error.textContent = 'Enter a five-digit ZIP code.';
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      input.removeAttribute('aria-invalid');
      error.hidden = true;
      loadZips(root.dataset.zipUrl).then(function () {
        var r = lookup(zip);
        if (!r) {
          error.textContent = 'We don’t have a zone for ' + zip + '. Try a nearby ZIP code, or tap the map where you live.';
          error.hidden = false;
          return;
        }
        r.zip = zip;
        store(r.zone);
        show(r);
      });
    });

    // Expanded view: the same card, moved to <body> so no sticky or stacking
    // ancestor can clip it, with a placeholder holding its place on the page.
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = root.querySelectorAll('button:not([hidden]), input, a[href]');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function open() {
      placeholder = document.createElement('div');
      placeholder.style.height = root.offsetHeight + 'px';
      root.parentNode.insertBefore(placeholder, root);
      document.body.appendChild(backdrop);
      document.body.appendChild(root);
      root.classList.add('is-open');
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      backdrop.hidden = false;
      openBtn.hidden = true; closeBtn.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      closeBtn.focus();
    }
    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.setAttribute('role', 'group');
      root.removeAttribute('aria-modal');
      backdrop.hidden = true;
      closeBtn.hidden = true; openBtn.hidden = false;
      placeholder.parentNode.insertBefore(root, placeholder);
      root.parentNode.insertBefore(backdrop, placeholder);
      placeholder.remove();
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
  });
})();
